import {
  getIsOdd,
  getIsOnlyReadElement,
  getTaskFromLookahead
} from '../common/validators';
import {
  formatTagsToString,
  prepareUIElements,
  registerTaskCallbacks,
  setupGlobalHandlers,
  setupMutationObserver
} from './utils';
import dropdownHTML from '../../components/dropdownHTML';
import { TemplateTag } from './TemplateTag';

const renderTags = (props) => {
  setupGlobalHandlers();

  const {
    column,
    activities,
    gantt,
    t,
    onlyRead,
    task,
    callbackOnClickCreate,
    callbackOnClickRemove,
    callbackOnSelection,
    mainObject,
    customMainClassName
  } = props;

  if (!task.isTask || !gantt) return '';

  const taskFromLookahead = getTaskFromLookahead(activities, gantt, task.id);
  const { subtradeRole } = gantt;
  const isOnlyReadElement = getIsOnlyReadElement(onlyRead, task, subtradeRole);
  const selectedObject = { ...task, ...(mainObject || {}) };
  const optionsList = gantt.toSelectTags;

  const searchPlaceholder = formatTagsToString(selectedObject.tags);

  registerTaskCallbacks(task.id, task, {
    taskFromLookahead,
    column,
    gantt,
    callbackOnSelection,
    callbackOnClickCreate,
    callbackOnClickRemove
  });

  const { placeholderHtml, optionsListHtml, createBtnHtml, removeBtnHtml } =
    prepareUIElements({
      selectedObject,
      optionsList,
      isOnlyReadElement,
      t,
      column,
      taskId: task.id
    });

  const dropdownContent = `
    <ul class="options-list" onscroll="event.stopPropagation()">
      ${createBtnHtml}
      ${optionsListHtml}
      ${removeBtnHtml}
    </ul>
  `;

  const dropdown = dropdownHTML({
    trigger: placeholderHtml,
    content: dropdownContent,
    width: column?.width,
    isReadOnly: isOnlyReadElement,
    id: `tags-dropdown-${task.id}`,
    customClass: `custom-tags-dropdown ${customMainClassName || ''}`,
    searchable: true,
    searchPlaceholder: searchPlaceholder
  });

  const html = `
    <div 
      class="${getIsOdd({ gantt, task }, 'tags') ? 'odd-col' : 'non-odd-col'} ${customMainClassName || ''}"
      data-task-id="${task.id}"
      data-column-name="${column.name}">
      ${dropdown}
      ${TemplateTag(task)}
    </div>
  `;

  setupMutationObserver(task.id, column.name, selectedObject, gantt);

  return html;
};

export default renderTags;
